import Box from "./Box";
import Icon from "./Icon";


export default function Token({ value, color, icon = "coin", size = 16 }) {
	return (
		<Box gap={0.5} sx={{ alignItems: "center", color }}>
			<Icon name={icon} size={size} />
			{value}
		</Box>
	);
}